import { Menu, Modal, Select, TextInput } from '@mantine/core';
import React, { useEffect, useRef, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import Nav from '../NavBar/Nav';
import "./travelInsurance.css"
import { City, Country, State } from "country-state-city";
import { PiCaretDown } from "react-icons/pi";
import {  IoLocationOutline } from "react-icons/io5";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";


import { FaDollarSign } from "react-icons/fa6";
import CustomPlacesCheckbox from '../TravelComponents/CustomPlacesSearch';
import FooterNew from '../NavBar/FooterNew';
import TravelDate from '../TravelComponents/Date';
import axios from 'axios';
import base_url from '../../api/bootapi';
import Swal from 'sweetalert2';

import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import images from "react-payment-inputs/images";
import { useDisclosure } from '@mantine/hooks';
import { IoIosCheckmarkCircle } from "react-icons/io";


const NewTravelInsurance = () => {



   const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // When scroll > 200px, make it sticky
      if (window.scrollY > 200) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [product, setProduct] = useState(null);

 const handleCheckboxChange = (e) => {
    console.log(e.target.checked);

    setIsPrimaryAddressChecked(e.target.checked);
  };


  const [isPrimaryAddressChecked, setIsPrimaryAddressChecked] = useState(false);
  

    useEffect(() => {
      if (isPrimaryAddressChecked) {
      

        const paymentData = {
      
     
      addressLine1: getValues('primaryTraveler.address.addressLine1'),
      city: getValues('primaryTraveler.address.city'),
      stateIsoCode: getValues('primaryTraveler.address.stateIsoCode'),
      countryIsoCode: getValues('primaryTraveler.address.countryIsoCode'),
          zipCode: getValues('primaryTraveler.address.zipCode'),
      
    };
       setValue("payments.0.creditCard.addressLine1", paymentData.addressLine1);
    setValue("payments.0.creditCard.city", paymentData.city);
    setValue("payments.0.creditCard.stateIsoCode", paymentData.stateIsoCode);
    setValue("payments.0.creditCard.countryIsoCode", paymentData.countryIsoCode);
    setValue("payments.0.creditCard.zipCode", paymentData.zipCode);
        
      } else {
         setValue("payments.0.creditCard.addressLine1", "");
    setValue("payments.0.creditCard.city", "");
    setValue("payments.0.creditCard.stateIsoCode", "");
    setValue("payments.0.creditCard.countryIsoCode", "");
    setValue("payments.0.creditCard.zipCode", "");
      }
    }, [isPrimaryAddressChecked]);
  

   const {
      wrapperProps,
      getCardImageProps,
      getCardNumberProps,
      getExpiryDateProps,
      getCVCProps,
    } = usePaymentInputs();

      const {
        control,
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
        trigger,
        setValue,
        setError,
        clearErrors,
        getValues,
        setFocus
      } = useForm({
        defaultValues: {
          departureDate: "",
          returnDate: "",
          depositDate:"",
          destinations: [],
          primaryTraveler: {
            firstName: "",
            middleName: "",
            lastName: "",
            dateOfBirth: "",
            tripCost: "",
              email: "",
            
            phoneNumbers: "",
            address: {
              addressLine1: "",
              addressLine2: "",
              city: "",
              stateIsoCode: "",
              countryIsoCode: "",
              zipCode: "",
            },
          },
          additionalTravelers: [],
          payments:[]
        },
         mode: "onChange",
      });
    
      const {
        fields: travelerFields,
        append: addTraveler,
        remove: removeTraveler,
      } = useFieldArray({ control, name: "additionalTravelers" });
    
     const selectedCountry = watch("primaryTraveler.address.countryIsoCode");
      const states = selectedCountry
        ? State.getStatesOfCountry(selectedCountry).map((s) => ({
            value: s.isoCode,
            label: `${s.name}`,
          }))
    : [];
  
   const selectedBillingCountry = watch("payments.0.creditCard.countryIsoCode");
      const billingStates = selectedBillingCountry
        ? State.getStatesOfCountry(selectedBillingCountry).map((s) => ({
            value: s.isoCode,
            label: `${s.name}`,
          }))
    : [];
  
  
  
  
  
   const onError = (errors) => {
     const firstErrorPath = getFirstErrorPath(errors);
     console.log("First Error Path --- ",firstErrorPath)
    if (firstErrorPath) {
      setFocus(firstErrorPath); // Focus the invalid input
     console.log("First Error Path --- ",`[name="${firstErrorPath}"]`)

      const el = document.querySelector(`[name="${firstErrorPath}"]`);
      console.log("element --- ")
      el?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  
 function getFirstErrorPath(errorsObj, parentKey = "") {
  for (const key of Object.keys(errorsObj)) {
    const currentPath = parentKey ? `${parentKey}.${key}` : key;
    const value = errorsObj[key];

    if (value?.message) return currentPath; // field directly has an error
    if (typeof value === "object") {
      const nestedPath = getFirstErrorPath(value, currentPath);
      if (nestedPath) return nestedPath;
    }
  }
  return null;
}

  
  const [menuOpened, setMenuOpened] = useState(false);


  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
    const [travelInsuranceData, setTravelInsuranceData] = useState(null);
  
  
  const getPlanDetails = async() => {
    const isValid = await trigger([
    "primaryTraveler",
      "additionalTravelers",
      "departureDate",
      "returnDate",
      "depositDate",
      "destinations",

    
    ]);
    
     if (!isValid) {
    console.log("Validation failed — please fill required fields");
    return;
    }
    

    let mainData = {

    }

    mainData.primaryTraveler = getValues('primaryTraveler')
    mainData.additionalTravelers = getValues('additionalTravelers')
    mainData.departureDate= getValues('departureDate');
          mainData.returnDate= getValues('returnDate');
          mainData.depositDate=getValues('depositDate');
          mainData.destinations= getValues('destinations');
     

 const data = structuredClone(mainData)
    console.log(data)

    setLoading(true);
    

    const formatted = {
      ...data,
      destinations: data.destinations.map((d) => ({
        // ...d,
        countryIsoCode: d.countryIsoCode || "",
         stateIsoCode: d.countryIsoCode === "US" ? d.stateIsoCode : "",
      })),
      additionalTravelers: data.additionalTravelers.map((traveler) => ({
        ...traveler,
        tripCost: Number(traveler.tripCost),
      })),
    };

    formatted.agentId = "agent1234";
    // const today = new Date().toISOString().split("T")[0];
    // formatted.depositDate = today;

    formatted.countryIsoCode =
      formatted.primaryTraveler?.address?.countryIsoCode || "";
    formatted.stateIsoCode =
      formatted.primaryTraveler?.address?.stateIsoCode || "";
    formatted.primaryTraveler.tripCost =
      Number(formatted.primaryTraveler.tripCost) || "";

    formatted.primaryTraveler.tripCost =
      Number(formatted.primaryTraveler.tripCost) || "";

    delete formatted.primaryTraveler.address;
    delete formatted.primaryTraveler.phoneNumbers;
    delete formatted.primaryTraveler.email;

    console.log("Form Submitted:", formatted);

    axios.post(`${base_url.api1}/tourapp/travel_insurance`, formatted).then(
      (response) => {
       
        setLoading(false);

      
        if (response?.data?.data?.errors) {
         
          Swal.fire({
            position: "center",
            width: "30rem",
            icon: "error",
            title: response?.data?.data?.errors[0]?.message ?? "No Plans Found",
            showCloseButton: true,
            showConfirmButton: false,
          });

          return;
        }
        const responseData = response?.data?.data?.data?.quote;
        
        setTravelInsuranceData(responseData);

        const result = responseData.find(item => item.productName === "Worldwide Trip Protector Platinum");

        setProduct(result)
        window.scrollTo(0, 0);

        
       
      },
      (error) => {
        // toast.error("User Not Created!");
        setLoading(false);
       

        Swal.fire({
          position: "center",
          width: "62rem",
          icon: "error",
          title: "Something went wrong!",
          showCloseButton: true,
          showConfirmButton: false,
        });
      }
    );
  };

  
 
//  const onSubmit = (data) => {

 

//     setLoading(true);
//     setFormData(data);
//     // preserve full details in state
//     localStorage.setItem("formData", JSON.stringify(data));

//     const formatted = {
//       ...data,
//       destinations: data.destinations.map((d) => ({
//         // ...d,
//         countryIsoCode: d.countryIsoCode || "",
//         stateIsoCode: d.stateIsoCode || "",
//       })),
//       additionalTravelers: data.additionalTravelers.map((traveler) => ({
//         ...traveler,
//         tripCost: Number(traveler.tripCost),
//       })),
//     };

//     formatted.agentId = "agent1234";
//     // const today = new Date().toISOString().split("T")[0];
//     // formatted.depositDate = today;

//     formatted.countryIsoCode =
//       formatted.primaryTraveler?.address?.countryIsoCode || "";
//     formatted.stateIsoCode =
//       formatted.primaryTraveler?.address?.stateIsoCode || "";
//     formatted.primaryTraveler.tripCost =
//       Number(formatted.primaryTraveler.tripCost) || "";

//     formatted.primaryTraveler.tripCost =
//       Number(formatted.primaryTraveler.tripCost) || "";

//     delete formatted.primaryTraveler.address;
//     delete formatted.primaryTraveler.phoneNumbers;
//     delete formatted.primaryTraveler.email;

//     console.log("Form Submitted:", formatted);

//     axios.post(`${base_url.api1}/tourapp/travel_insurance`, formatted).then(
//       (response) => {
//         console.log(response);
//         setLoading(false);

//         // console.log(response?.data?.data.errors[0].message);
//         if (response?.data?.data?.errors) {
//           console.log(errors);
//           Swal.fire({
//             position: "center",
//             width: "30rem",
//             icon: "error",
//             title: response?.data?.data?.errors[0]?.message ?? "No Plans Found",
//             showCloseButton: true,
//             showConfirmButton: false,
//           });

//           return;
//         }
//         const responseData = response?.data?.data?.data?.quote;
//         localStorage.setItem("quote", JSON.stringify(responseData));
//         setTravelInsuranceData(responseData);

//         const result = responseData.find(item => item.productName === "Worldwide Trip Protector Platinum")?.pricing;

//         setPricing(result)
//         window.scrollTo(0, 0);

        
       
//       },
//       (error) => {
//         // toast.error("User Not Created!");
//         setLoading(false);
//         setTravelInsuranceData(null);

//         Swal.fire({
//           position: "center",
//           width: "62rem",
//           icon: "error",
//           title: "Something went wrong!",
//           showCloseButton: true,
//           showConfirmButton: false,
//         });
//       }
//     );
//   };

  
  const handlePurchageClicked = () => {

    handleSubmit(onSubmit, onError)();

  }
  
  
  
   const onSubmit = (data) => {
     
      setLoading(true);
  
      const requestFormData = data;
  
      const formatted = {
        ...requestFormData,
        destinations: requestFormData.destinations.map((d) => ({
          
          countryIsoCode: d.countryIsoCode || "",
          stateIsoCode: d.countryIsoCode === "US" ? d.stateIsoCode : "",
        })),
        additionalTravelers: requestFormData.additionalTravelers.map(
          (traveler) => ({
            ...traveler,
            tripCost: Number(traveler.tripCost),
          })
        ),
      };
  
      if (
        !formatted.additionalTravelers ||
        formatted.additionalTravelers.length === 0
      ) {
        delete formatted.additionalTravelers;
      }
  
      formatted.agentId = "agent1234";
      // const today = new Date().toISOString().split("T")[0];
      // formatted.depositDate = today;
  
      if (formatted.primaryTraveler) {
        formatted.primaryTraveler = {
          ...formatted.primaryTraveler,
          tripCost: Number(formatted.primaryTraveler.tripCost) || 0,
          address: {
            ...formatted.primaryTraveler.address,
            countryIsoCode:
              formatted.primaryTraveler?.address?.countryIsoCode || "",
            stateIsoCode:
              formatted.primaryTraveler?.address?.stateIsoCode || "",
          },
        };



        
  
        // Top-level country/state if you need them
        // formatted.countryIsoCode =
        //   formatted.primaryTraveler.address.countryIsoCode;
        // formatted.stateIsoCode = formatted.primaryTraveler.address.stateIsoCode;
      }
      formatted.productCode = product?.productCode;
  
      function normalizeExpiry(expiry) {
        if (!expiry) return "";
  
        const [month, year] = expiry.split(" / ");
  
        // react-payment-inputs gives only last 2 digits
        const fullYear = `20${year}`;
  
        return { month, year: fullYear };
      }
  
      const { month, year } = normalizeExpiry(data.payments[0].creditCard.expiryDate);
  
    
      //   {
      //     amount: Number(product?.pricing?.premium),
      //     creditCard: {
      //       cardNumber: data.cardNumber,
      //       expirationMonth: Number(month),
      //       expirationYear: Number(year),
      //       cardVerificationValue: data?.cvc,
      //       firstName: data?.firstName,
  
      //       lastName: data?.lastName,
      //       addressLine1: data?.address,
      //       city: data?.city,
      //       stateIsoCode: data?.stateIsoCode?.value,
      //       countryIsoCode: data?.countryIsoCode?.value,
      //       zipCode: data?.zipCode,
      //     },
      //   },
     // ];
     
     
  
     if (formatted.payments) {
       formatted.payments = [{
         ...formatted.payments[0],
         amount: Number(product?.pricing?.premium),
         creditCard: {
      ...formatted.payments[0].creditCard,
      expirationMonth: Number(month),
           expirationYear: Number(year),
      cardVerificationValue:formatted?.payments[0]?.creditCard?.cvc
    },
         
       }];
       

     }
  
      delete formatted.payments[0].creditCard.expiryDate;
      delete formatted.payments[0].creditCard.cvc;
      // delete formatted.primaryTraveler.phoneNumbers;
      // delete formatted.primaryTraveler.email;
  
      console.log("Form Submitted:", formatted);
  
      axios
        .post(`${base_url.api1}/tourapp/travel_insurance/purchase`, formatted)
        .then(
          (response) => {
            console.log(response);
            setLoading(false);

     
            setPurchase(response?.data?.data?.data?.purchase);
            successOpen();
            
          },
          (error) => {
            // toast.error("User Not Created!");
            setLoading(false);
            // setTravelInsuranceData(null);
  
            Swal.fire({
              position: "center",
              width: "40rem",
              icon: "error",
              title: "Something went wrong!",
              showCloseButton: true,
              showConfirmButton: false,
            });
          }
        );
    };
    const [purchase, setPurchase] = useState(null);
  

  const [succesOpened, { open: successOpen, close: successClose }] =
    useDisclosure(false);
  function handleSuccessClose() {
    successClose();
    reset()
    setProduct(null)
    window.scrollTo(0,0)
    
  }


    function handleDownloadAll() {
    const files = [
      { url: purchase.cobDownloadLink, name: "COB-Document.pdf" },
      { url: purchase.eobDownloadLink, name: "EOB-Document.pdf" },
    ];

    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.setAttribute("download", file.name);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  }
  return (
    <div>

       <Modal
              opened={succesOpened}
              onClose={handleSuccessClose}
              closeOnClickOutside={false}
            >
              <div className="successful-modal">
                <div>
                  <IoIosCheckmarkCircle size={"80px"} color="#0bab44" />
                </div>
      
                <h1>Payment Successfull</h1>
      
                <p>Plan Number : {purchase?.planNumber}</p>
      
                <button onClick={handleDownloadAll}>Download documents</button>
              </div>
            </Modal>
      
       <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          
          <Nav/>
          

      <div className='new-travel-container'>
          <form
              onSubmit={handleSubmit(onSubmit,onError)}
          
              className='new-travel-form'
          >
              
              <div className='new-travel-box'>
                  
                  <h2 className='new-travel-header'>Traveler Information</h2>

                  <div className="travel-input-box">
                      <div className="travel-input-box-grid">
                          
                         
                   
                          <Controller
                            name={`primaryTraveler.tripCost`}
                                    control={control}
                rules={{
                  required: "Please enter the trip cost",
                  validate: (value) =>
      parseFloat(value) >= 0 || "Trip cost cannot be negative",
  
                                      
                                     }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          //   styles={{
                                          //       root: {
                                          //          width:"300px"
                                          //      }
                                        //  }}
                                         onWheel={(e) => e.target.blur()}
                                            leftSection={<FaDollarSign/>}
                                            label="Trip Cost for Primary Traveler"
                                            placeholder="0.00"
                                        value={value}
                                        onKeyDown={(e) => {
        // Prevent invalid characters from even being typed
        if (
          ["e", "E", "+", "-", ",", " "].includes(e.key)
        ) {
          e.preventDefault();
        }
      }}
                                        type='number'
                                        name={name}
                                           onChange={(e) => {
        let inputValue = e.target.value;

      
        if (/^[0-9]*\.?[0-9]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
                                            error={errors?.primaryTraveler?.tripCost?.message }
                                            />
                            )}
                          />
                          
                      </div>
                            

                      <div className="travel-input-box-grid">
                          
                   
                          <Controller
                            name={`primaryTraveler.firstName`}
                                    control={control}
                                    rules={{ required: "Please enter first name" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                                                                 name={name}

                                            label="First Name"
                                            // placeholder="John Will"
                                        value={value}
                                        
                                            onChange={(e) => {
        const inputValue = e.target.value;

        
        if (/^[A-Za-z ]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
      onKeyDown={(e) => {
      
        if (!/^[a-zA-Z ]$/.test(e.key) && e.key.length === 1) {
          e.preventDefault();
        }
      }}
                                            error={errors?.primaryTraveler?.firstName?.message }
                                            />
                            )}
                          />

                            <Controller
                            name={`primaryTraveler.middleName`}
                                    control={control}
                                    
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            
                                            label="Middle Name"
                                                                                    name={name}
                                            
                                            value={value}
                                                     onChange={(e) => {
        const inputValue = e.target.value;

        
        if (/^[A-Za-z ]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
      onKeyDown={(e) => {
      
        if (!/^[a-zA-Z ]$/.test(e.key) && e.key.length === 1) {
          e.preventDefault();
        }
      }}
                                            error={errors?.primaryTraveler?.middleName?.message }
                                            />
                            )}
                          />

                            <Controller
                            name={`primaryTraveler.lastName`}
                                    control={control}
                                    rules={{ required: "Please enter last name" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            
                                            label="Last Name"
                                                                                    name={name}
                                                      onChange={(e) => {
        const inputValue = e.target.value;

        
        if (/^[A-Za-z ]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
      onKeyDown={(e) => {
      
        if (!/^[a-zA-Z ]$/.test(e.key) && e.key.length === 1) {
          e.preventDefault();
        }
      }}
                                            value={value}
                                           
                                            error={errors?.primaryTraveler?.lastName?.message }
                                            />
                            )}
                          />

                          
                             <div className="travel-input-wrapper">
            <label>Date of Birth <span style={{color:"#fa5252"}}>*</span>

</label>

          <Controller
      name="primaryTraveler.dateOfBirth"
                  control={control}
                  rules={{ required: "Please enter date of birth" }}
      render={({ field }) => (
        <TravelDate
           {...field}
          value={field.value}
          onChange={(date) => field.onChange(date)}
        />
      )}
    />

            {errors?.primaryTraveler?.dateOfBirth?.message && <p className="travel-error-text">
              {errors?.primaryTraveler?.dateOfBirth.message}
            </p>} 

                      </div>

                          
                          
                      </div>
                      
                      <div className="travel-input-box-grid">
                          
                   
                          <Controller
                            name={`primaryTraveler.email`}
                                    control={control}
                rules={{
                  required: "Please enter email",
                                       pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Please enter a valid email address",
    },
                                     }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                            type='email'
                                            label="Email"
                                            placeholder="john@gmail.com"
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.primaryTraveler?.email?.message }
                                            />
                            )}
                          />

                          

                            <Controller
                            name={`primaryTraveler.phoneNumbers`}
                                    control={control}
                                    rules={{ required: "Please enter phone number" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            type='number'
                                            label="Phone Number"
                                                                                    name={name}
                                            onWheel={(e) => e.target.blur()}
                                            value={value}
                                            onChange={onChange}
                                            error={errors?.primaryTraveler?.phoneNumbers?.message }
                                            />
                            )}
                          />

                           

                          
                          
                             </div>
                      

                      <div>
                          <h5 className='sub-traveler-header'>Address Details</h5>

                          <div className="travel-input-box-grid">
                               <Controller
                            name={`primaryTraveler.address.countryIsoCode`}
                                    control={control}
                                    rules={{ required: "Please select country" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <Select
                                           
                                            withAsterisk
                                         
                                            label="Country"
                                            placeholder="Select Country"
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            searchable
                                            data={Country.getAllCountries().map((c) => ({
                                                                    value: c.isoCode,
                                                                    label: c.name,
                                                                  }))}
                                            error={errors?.primaryTraveler?.address?.countryIsoCode?.message }
                                            />
                            )}
                              />
                              
                               <Controller
                            name={`primaryTraveler.address.stateIsoCode`}
                                    control={control}
                                    rules={{ required: "Please select country" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <Select
                                           
                                            withAsterisk
                                         
                                            label="State"
                                            placeholder="Select State"
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            searchable
                                            data={states}
                                            disabled={!selectedCountry}
                                            error={errors?.primaryTraveler?.address?.stateIsoCode?.message }
                                            />
                            )}
                              />
                              
                                <Controller
                            name={`primaryTraveler.address.city`}
                                    control={control}
                                    rules={{ required: "Please enter city" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            
                                            label="City"
                                            
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.primaryTraveler?.address?.city?.message }
                                            />
                            )}
                              />
                              

                                 <Controller
                            name={`primaryTraveler.address.zipCode`}
                                    control={control}
                                    rules={{ required: "Please enter zipcode" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            
                                            label="Zipcode"
                                            
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.primaryTraveler?.address?.zipCode?.message }
                                            />
                            )}
                          />

                           </div>

                      </div>

                      
                      <div className="travel-input-box-grid-two">
                          
 <Controller
                            name={`primaryTraveler.address.addressLine1`}
                                    control={control}
                                    rules={{ required: "Please enter street address" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                            
                                            label="Street Address"
                                           
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.primaryTraveler?.address?.addressLine1?.message }
                                            />
                            )}
                          />

                            <Controller
                            name={`primaryTraveler.address.addressLine2`}
                                    control={control}
                                    
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            
                                            label="Address Line 2"
                                            
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.primaryTraveler?.address?.addressLine2?.message }
                                            />
                            )}
                          />

                      </div>


                      <div>
                          
                          {travelerFields.map((field, index) => (
                              <div>
                                  
                                  <div className='additonal-traveler-header'>
                                      
                                      <h5>
                                          Traveler {
                                              index + 2
                                          }
                                      </h5>

                                      <button type='button' className='remove-btn' onClick={() => removeTraveler(index)}>
                                          Remove
                                      </button>

                                  </div>
                                   <div className="travel-input-box-grid">
                          
                         
                   
                          <Controller
                            name={`additionalTravelers.${index}.tripCost`}
                                    control={control}
                                    rules={{ required: "Please enter the trip cost" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           withAsterisk
                                            leftSection={<FaDollarSign/>}
                                            label={"Trip Cost for Traveler "+(index+2)}
                                            placeholder="0.00"
                                            value={value}
                                        type='number'
                                                                                    name={name}
                                        onWheel={(e) => e.target.blur()}
                                            onChange={onChange}
                                            error={errors?.additionalTravelers?.[index]?.tripCost?.message }
                                            />
                            )}
                          />
                          
                      </div>
                            

                      <div className="travel-input-box-grid">
                          
                   
                          <Controller
                            name={`additionalTravelers.${index}.firstName`}
                                    control={control}
                                    rules={{ required: "Please enter first name" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                            
                                            label="First Name"
                                            placeholder="John Will"
                                            value={value}
                                        onChange={onChange}
                                                                                    name={name}
                                        
                                            error={errors?.additionalTravelers?.[index]?.firstName?.message }
                                            />
                            )}
                          />

                            <Controller
                            name={`additionalTravelers.${index}.lastName`}
                                    control={control}
                                     rules={{ required: "Please enter last name" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                            label="Last Name"
                                            
                                            value={value}
                                        onChange={onChange}
                                                                                    name={name}
                                        
                                            error={errors?.additionalTravelers?.[index]?.lastName?.message }
                                            />
                            )}
                          />

                          
                                         <div className="travel-input-wrapper">
            <label>Date of Birth <span style={{color:"#fa5252"}}>*</span>

</label>

          <Controller
      name={`additionalTravelers.${index}.dateOfBirth`}
                  control={control}
                  rules={{ required: "Please enter date of birth" }}
      render={({ field }) => (
        <TravelDate
           {...field}
          value={field.value}
          onChange={(date) => field.onChange(date)}
        />
      )}
    />

            {errors?.additionalTravelers?.[index]?.dateOfBirth?.message && <p className="travel-error-text">
              {errors?.additionalTravelers?.[index]?.dateOfBirth?.message}
            </p>} 

                      </div>

                          

                          
                          
                      </div>

                              </div>
                              
                          ))}                      </div>
                      <button className='add-traveler-btn'  type="button"
         
          onClick={() =>
            addTraveler({
              firstName: "",
              lastName: "",
              dateOfBirth: "",
              tripCost: "",
            })
          }>Add Traveler</button>

                       
                  </div>


                 
               
                  

              </div>


              <div className='new-travel-box' style={{ marginTop:"40px"}}>
                  <h2 className='new-travel-header'>Trip Information</h2>
<div className="travel-input-box">

                  <div className="travel-input-box-grid-two" style={{marginTop:"0px"}}>
                      
                      <div className="travel-input-wrapper">
                                  <label>Destinations</label>
                       <Controller
                          name="destinations"
                                      control={control}
                                      rules={{
                                  required: "Please select at least one destination",
                                }}
                                      render={({ field: { onChange, value } }) => (
                                        <>
                                          <Menu shadow="md" width={'target'} middlewares={{ flip: false, shift: false }}   opened={menuOpened}
                            onChange={setMenuOpened}>
                                            <Menu.Target>
                      
                                    
                                              <div className="travel-input">
                      
                                                <IoLocationOutline size={'24px'} />
                                                <span className="travel-input-text"  name="destinations">
                                                  {value.length === 0 ? (
                                                    <p style={{ color: "#a4a4a4", margin: 0, padding: 0 }}>
                                                      Select Destinations
                                                    </p>
                                                  ) : (
                                                    (() => {
                                                      const names = value.map((d) => d.countryName);
                                                      const shown = names.slice(0, 2).join(", ");
                                                      const remaining = names.length - 2;
                                                      return remaining > 0 ? `${shown} and ${remaining} more` : shown;
                                                    })()
                                                  )}
                                                </span>
                      
                                                <PiCaretDown size={'18px'} />
                                              </div>
                                            </Menu.Target>
                                    
                                            <Menu.Dropdown>
                                              <div>
                                                <div>
                                                  <CustomPlacesCheckbox  onSelect={(places) => { 
                                                    onChange(places);
                                                    trigger('destinations')
                                                  }} value={value} />
                      
                                                  <div>
                                                    <button className="menu-done-btn" onClick={()=>setMenuOpened(false)}>Done</button>
                                                  </div>
                                           
                                                </div>
                                              </div>
                                            </Menu.Dropdown>
                                    
                                          </Menu>
                                        
                                        </>
                                      
                                      )}
                                    />
                      
                          
                      
                                 {errors.destinations?.message && <p className="travel-error-text">
                                    {errors.destinations?.message}
                                  </p>} 
                      
                                </div>
                  </div>


                  <div className="travel-input-box-grid">
                      
                         <div className="travel-input-wrapper">
            <label>Departure Date</label>

          <Controller
      name="departureDate"
                  control={control}
                  rules={{ required: "Please select departure date" }}
                  
      render={({ field }) => (
        <TravelDate
          {...field}
          value={field.value}
          onChange={(date) => field.onChange(date)}
        />
      )}
    />

            {errors.departureDate?.message && <p className="travel-error-text">
              {errors.departureDate?.message}
            </p>} 

            </div>
            
            <div className="travel-input-wrapper">
            <label>Return Date

</label>

          <Controller
      name="returnDate"
                  control={control}
                  rules={{ required: "Please select return date" }}
      render={({ field }) => (
        <TravelDate
           {...field}
          value={field.value}
          onChange={(date) => field.onChange(date)}
        />
      )}
    />

            {errors.returnDate?.message && <p className="travel-error-text">
              {errors.returnDate?.message}
            </p>} 

              </div>
              

                <div className="travel-input-wrapper">
            <label>Initial Trip Deposit Date

</label>

          <Controller
      name="depositDate"
                  control={control}
                  rules={{ required: "Please select deposite date" }}
      render={({ field }) => (
        <TravelDate
           {...field}
          value={field.value}
          onChange={(date) => field.onChange(date)}
        />
      )}
    />

            {errors.depositDate?.message && <p className="travel-error-text">
              {errors.depositDate?.message}
            </p>} 

                      </div>
                      

                      
                      </div>

                      </div>

                  

          </div>
          
          {
            product ? <>

            <div className='new-travel-box' style={{ marginTop:"40px"}}>
                  <h2 className='new-travel-header'>Payment Information</h2>
            <div className="travel-input-box">
               <div className="field-wrapper" style={{ marginBottom: "20px" }}>
                                <label style={{position:"initial",marginBottom:"10px"}}>Card Details</label>
                                <PaymentInputsWrapper
                                  {...wrapperProps}
                                  className="custom-card-wrapper"
                                >
                                  <svg {...getCardImageProps({ images })} />
              
                                  {/* Card Number */}
                                  <Controller
                                    name="payments.0.creditCard.cardNumber"
                                    control={control}
                                    rules={{ required: "Card number is required" }}
                                    render={({ field }) => (
                                      <input
                                        {...getCardNumberProps({
                                          onChange: field.onChange,
                                          onBlur: field.onBlur,
                                          value: field.value,
                                          className: "card-input",
                                        })}
                                      />
                                    )}
                                  />
              
                                  {/* Expiry Date */}
                                  <Controller
                                    name="payments.0.creditCard.expiryDate"
                                    control={control}
                                    rules={{ required: "Expiry date is required" }}
                                    render={({ field }) => (
                                      <input
                                        {...getExpiryDateProps({
                                          onChange: field.onChange,
                                          onBlur: field.onBlur,
                                          value: field.value,
                                          className: "card-input",
                                        })}
                                      />
                                    )}
                                  />
              
                                  {/* CVC */}
                                  <Controller
                                    name="payments.0.creditCard.cvc"
                                    control={control}
                                    rules={{ required: "CVC is required" }}
                                    render={({ field }) => (
                                      <input
                                        {...getCVCProps({
                                          onChange: field.onChange,
                                          onBlur: field.onBlur,
                                          value: field.value,
                                          className: "card-input",
                                        })}
                                      />
                                    )}
                                  />
                                </PaymentInputsWrapper>
              
                                {(errors?.payments?.[0]?.creditCard?.cardNumber ||
                                  errors?.payments?.[0]?.creditCard?.cvv ||
                                  errors?.payments?.[0]?.creditCard?.expiryDate ) && (
                                  <p className="error-text">Please fill card details</p>
                                )}
              </div>
              

                <div className="travel-input-box-grid">
                          
                   
                          <Controller
                            name={`payments.0.creditCard.firstName`}
                                    control={control}
                                    rules={{ required: "Please enter first name" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                                                                 name={name}

                                            label="First Name"
                                            // placeholder="John Will"
                                        value={value}
                                        
                                            onChange={(e) => {
        const inputValue = e.target.value;

        
        if (/^[A-Za-z ]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
      onKeyDown={(e) => {
      
        if (!/^[a-zA-Z ]$/.test(e.key) && e.key.length === 1) {
          e.preventDefault();
        }
      }}
                                            error={errors?.payments?.[0]?.creditCard?.firstName?.message}
                                            />
                            )}
                          />

                            <Controller
                                                       name={`payments.0.creditCard.middleName`}

                                    control={control}
                                    
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            
                                            label="Middle Name"
                                                                                    name={name}
                                            
                                            value={value}
                                                     onChange={(e) => {
        const inputValue = e.target.value;

        
        if (/^[A-Za-z ]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
      onKeyDown={(e) => {
      
        if (!/^[a-zA-Z ]$/.test(e.key) && e.key.length === 1) {
          e.preventDefault();
        }
      }}
                                            
                                            />
                            )}
                          />

                            <Controller
                                                       name={`payments.0.creditCard.lastName`}

                                    control={control}
                                    rules={{ required: "Please enter last name" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            
                                            label="Last Name"
                                                                                    name={name}
                                                      onChange={(e) => {
        const inputValue = e.target.value;

        
        if (/^[A-Za-z ]*$/.test(inputValue)) {
          onChange(inputValue);
        }
      }}
      onKeyDown={(e) => {
      
        if (!/^[a-zA-Z ]$/.test(e.key) && e.key.length === 1) {
          e.preventDefault();
        }
      }}
                                            value={value}
                                           
                                            error={errors?.payments?.[0]?.creditCard?.lastName?.message }
                                            />
                            )}
                          />

                          
                          

                          
                          
                      </div>
                      


                                    <div>
                <h5 className='sub-traveler-header'>Billing Address Details</h5>
                
                 <label className='use-same-address-checkbox'>
              <input
                type="checkbox"
                onChange={handleCheckboxChange}
                checked={isPrimaryAddressChecked}
              />{" "}
              Use Primary Traveler Address
            </label>


                          <div className="travel-input-box-grid">
                               <Controller
                            name={`payments.0.creditCard.countryIsoCode`}
                                    control={control}
                                    rules={{ required: "Please select country" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <Select
                                           
                                            withAsterisk
                                         
                                            label="Country"
                                            placeholder="Select Country"
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            searchable
                                            data={Country.getAllCountries().map((c) => ({
                                                                    value: c.isoCode,
                                                                    label: c.name,
                                                                  }))}
                                            error={errors?.payments?.[0]?.creditCard?.countryIsoCode?.message }
                                            />
                            )}
                              />
                              
                               <Controller
                            name={`payments.0.creditCard.stateIsoCode`}
                                    control={control}
                                    rules={{ required: "Please select country" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <Select
                                           
                                            withAsterisk
                                         
                                            label="State"
                                            placeholder="Select State"
                                             value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            searchable
                                            data={billingStates}
                                            disabled={!selectedBillingCountry}
                                            error={errors?.payments?.[0]?.creditCard?.stateIsoCode?.message }
                                            />
                            )}
                              />
                              
                                <Controller
                            name={`payments.0.creditCard.city`}
                                    control={control}
                                    rules={{ required: "Please enter city" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            
                                            label="City"
                                            
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.payments?.[0]?.creditCard?.city?.message }
                                            />
                            )}
                              />
                              

                                 <Controller
                            name={`payments.0.creditCard.zipCode`}
                                    control={control}
                                    rules={{ required: "Please enter zipcode" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                          
                                            withAsterisk
                                            
                                            label="Zipcode"
                                            
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.payments?.[0]?.creditCard?.zipCode?.message }
                                            />
                            )}
                          />

                           </div>

                    

                      
                      <div className="travel-input-box-grid-two">
                          
 <Controller 
                            name={`payments.0.creditCard.addressLine1`}
                                    control={control}
                                    rules={{ required: "Please enter street address" }}
                                    render={({ field:{onChange,value,name} }) => (
                                        <TextInput
                                           
                                            withAsterisk
                                            
                                            label="Street Address"
                                           
                                        value={value}
                                                                                    name={name}
                                        
                                            onChange={onChange}
                                            error={errors?.payments?.[0]?.creditCard?.addressLine1?.message }
                                            />
                            )}
                          />

                         

                      </div>
                </div>

</div>

          </div>
          

                {/* <button className='add-traveler-btn'  type="submit" 
         
         
              >Purchase</button> */}
              
              </> :  <button className='add-traveler-btn'  type="button" onClick={getPlanDetails}
         
         
            >Get Quote</button>
          
          }
              

        </form>
        
        <div  className={`payment-box-wrapper`} >
          {
           product ?  <div className={`payment-box ${isSticky ? "sticky" : ""}`}>
            <h2 className='new-travel-header'>Quote Summary</h2>

         

              <div style={{padding:"15px"}}>
            <div className="payment-plan-title-wrapper">
              <h5>Worldwide Trip Protector Platinum</h5>{" "}
              {/* <span>(2 Travelers)</span> */}
            </div>

            <div>
              {product?.pricing?.travelerBreakdown?.map((priceItem, index) => {
                return (
                  <div className="payment-traveler">
                    <div className="payment-traveler-header">
                      {index === 0 ? "Primary Traveler" : `Companion ${index}`}
                    </div>

                    {priceItem?.pricingDetail?.map((planCoverage, index) => {
                      return (
                        <div className="payment-plan-price">
                          <span>
                            {planCoverage?.productCoverageDescription}
                          </span>

                          <span>${planCoverage?.price}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              })}

              <div className="total-product-price">
                <div className="total-product-price-header-wrapper">
                  <span>Total Plan Cost</span>

                  <span>${product?.pricing?.premium}</span>
                </div>
                <button onClick={handlePurchageClicked}>Purchase</button>
              </div>
                </div>
                
                </div>
          </div> :<p style={{marginTop:"100px"}}><span style={{color:"red"}}>*</span> all fields are required</p>
          }
         
        </div>

          </div>
         
          
          <FooterNew/>
          
          
    </div>
  )
}

export default NewTravelInsurance